import React from 'react';
import { useDocument } from '@nandorojo/swr-firestore';
import { SettingCollectionPath } from '@typings/collections.enum';
import { ImouseSet } from '@typings/setting/mouseSet.interface';
import ClickEffects from './ClickEffects';

function ClickEffectsManager() {
  const { data: mouseSet } = useDocument<ImouseSet>(
    SettingCollectionPath.MOUSE,
    { listen: true },
  );

  if (!mouseSet?.clickEffect) return null;

  const {
    isActive,
    type,
    color,
    color2,
    size,
    duration
  } = mouseSet.clickEffect;

  return (
    <ClickEffects
      effectType={type}
      isActive={isActive}
      color={color}
      color2={color2 || color}
      size={size}
      duration={duration}
    />
  );
}

export default ClickEffectsManager; 